import { createFolioSearchClient } from '../folioSearchClient';

export const relationshipCompanySearch = createFolioSearchClient({
	additionalSearchParameters: {
		sort_by: 'lastUpdated:desc',
	},
});
